<template>
    <div style="padding: 2% 0;" :class="bgClass">

        <div class="main-sponsor-wrapper">
            <div class="sponsor-wrapper">
                <div class="montserrat-600 sub-text-one">THE STRENGTH BEHIND OUR</div>
                <div class="poppins-bold sub-text-two fontColor2">SPONSORS</div>
                <div class="montserrat-600 sub-text-one max-width-2 sub-text-three">
                    We are deeply grateful to the organizations and individuals who have generously contributed their 
                    time, resources, ideas, and support toward the success of our association. Your dedication and commitment 
                    have played a vital role in our journey, and we truly appreciate your invaluable contributions.
                </div>
                <br/>
                <splide :options="options">
                    <splide-slide v-for="(image, index) in images" :key="index">
                        <img :src="image" class="carousel-image" />
                    </splide-slide>
                </splide>
            </div>
            
            <div class="fb-frane-wrapper">
                <div class="montserrat-600" style="padding-bottom: 10px;">Like Us On Facebook</div>
                <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fprofile.php%3Fid%3D100057645450325&tabs=timeline&width=350&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=519163378452257" 
                    height="500" 
                    class="fb-frame"
                    style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" 
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share">
                </iframe>
            </div>
        </div>
    
    </div>

</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/splide.min.css';

export default {
  name: 'TheSponsor',
  components: {
    Splide,
    SplideSlide
  },
  props: {
    bgClass: String,
  },
  data() {
    return {
        images: [
            require('@/assets/images/sponsors/sponsors-01.png'),
            require('@/assets/images/sponsors/sponsors-02.png'),
            require('@/assets/images/sponsors/sponsors-03.png'),
            require('@/assets/images/sponsors/sponsors-04.png'),
            require('@/assets/images/sponsors/sponsors-05.png'),
        ],
        options: {
            type: 'loop',
            perPage: 3,
            perMove: 1,
            interval: 1500,
            gap: '1rem',
            autoplay: true,
            // pauseOnHover: true,
            arrows: true,
            pagination: true,
            breakpoints: {
                768: {
                    perPage: 1
                },
                1638: {
                    perPage: 2
                }
            }   
      }
    }
  },
  mounted() {
    // Wait for DOM to be ready and initialize Owl Carousel
    
  }
}
</script>

<style scoped>

.main-sponsor-wrapper { color: #666666; text-align: center;}
.sponsor-wrapper { width: 95%; margin: 0 auto;}
.fb-frane-wrapper {width: 90%; padding-top: 25px; margin: 0 auto;}
img {
    width: 200px;
}

.fb-frame{
    width: 350px;
}

@media screen and (min-width: 640px) {
    img {
        width: 300px;
    }
}
@media screen and (min-width: 1024px) {
    img {
        width: 400px;
    }
}
@media screen and (min-width: 1440px) {
    .main-sponsor-wrapper {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      justify-content: center;
    }
    .sponsor-wrapper {width: 70%; padding-top: 2%;}
    .fb-frane-wrapper {width: 20%; padding-top: 0;}
    img {width: 400px;}
    .fb-frame{
        width: 100%;
    }
}
</style>